import React from "react";

import { Banner } from "@/design-system/components/Banner/Banner";

export function ConsentLoadError({ retry }: { retry: () => void }) {
  return (
    <Banner type="error">
      We couldn’t load your consent settings, so the wizard can’t tell what’s
      already set up.{" "}
      <button
        type="button"
        className="cursor-pointer underline"
        onClick={retry}
      >
        Try again
      </button>
    </Banner>
  );
}
